import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer/footer.component';
import { AppComponent } from './app.component';
import { AllDeviceGreaphComponent } from './bottom_menu/all-device-greaph/all-device-greaph.component';
import { BiReportComponent } from './bottom_menu/bi-report/bi-report.component';
import { LoginComponent } from './Auth/login/login.component';


import { DashboardComponent } from './dashboard/dashboard/dashboard.component';
import { BeforeLoginService } from './Services/before-login.service';
import { AfterLoginService } from './Services/after-login.service';
import { SignupComponent } from './Auth/signup/signup.component';
import { RequestResetComponent } from './Auth/password/request-reset/request-reset.component';
import { ResponseResetComponent } from './Auth/password/response-reset/response-reset.component';


const routes: Routes = [
  { path: '', 
    component: LoginComponent
  },
  /*{ path: 'all_device_graph', 
    component: AllDeviceGreaphComponent ,
    canActivate : [AfterLoginService],
    outlet : 'footer'
  },

  { path: 'bi_report',
   component: BiReportComponent ,
   canActivate : [AfterLoginService],
   outlet : 'footer'
  },*/
  {
    path: 'login',
    component: LoginComponent,
  },

 {
    path: 'signup',
    component: SignupComponent,
    canActivate : [BeforeLoginService]
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate : [AfterLoginService],
    children : [
      { path: 'all_device_graph', 
        component: AllDeviceGreaphComponent ,
        canActivate : [AfterLoginService],
        outlet : 'footer'
      },

      { path: 'bi_report',
      component: BiReportComponent ,
      canActivate : [AfterLoginService],
      outlet : 'footer'
      }
   ]
  },
  {
    path: 'request-password-reset',
    component: RequestResetComponent,
    canActivate : [BeforeLoginService]
  },
  {
    path: 'reset-responce',
    component: ResponseResetComponent,
    canActivate : [BeforeLoginService]
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
